import { Flex, Icon, Text } from '@chakra-ui/react'
import { FaRegArrowAltCircleRight } from 'react-icons/fa'

export function OptionButton({ option, onSelect }) {
  return (
    <Flex
      gap={2}
      alignItems="center"
      maxW="470px"
      w="100%"
      bg="#F5F5F5"
      py={3}
      px={5}
      onClick={onSelect}
      cursor="pointer"
      _hover={{ bg: '#E5E5E5' }}
    >
      <Text fontWeight="bold">Consultar por</Text>
      <Text fontWeight="bold" textTransform="uppercase" color="#378BBF">
        {option}
      </Text>

      <Icon
        as={FaRegArrowAltCircleRight}
        color="#378BBF"
        fontSize="20px"
        ml="auto"
      />
    </Flex>
  )
}
